import { __assign as r } from "tslib";
import { assign as e, stop as n } from "xstate/lib/actions";

var t = function t(r) {
  return n(r);
},
    u = e({
  attributeToVerify: function attributeToVerify(r) {}
}),
    o = e({
  challengeName: function challengeName(r) {}
}),
    a = e({
  requiredAttributes: function requiredAttributes(r) {}
}),
    i = e({
  remoteError: function remoteError(r) {
    return "";
  }
}),
    c = e({
  formValues: function formValues(r) {
    return {};
  }
}),
    s = e({
  touched: function touched(r) {
    return {};
  }
}),
    l = e({
  unverifiedAttributes: function unverifiedAttributes(r) {}
}),
    d = e({
  username: function username(r) {}
}),
    f = e({
  validationError: function validationError(r) {
    return {};
  }
}),
    m = e({
  challengeName: function challengeName(r, e) {
    var n;
    return null === (n = e.data) || void 0 === n ? void 0 : n.challengeName;
  }
}),
    v = e({
  requiredAttributes: function requiredAttributes(r, e) {
    var n, t;
    return null === (t = null === (n = e.data) || void 0 === n ? void 0 : n.challengeParam) || void 0 === t ? void 0 : t.requiredAttributes;
  }
}),
    h = e({
  redirectIntent: function redirectIntent(r) {
    return "confirmPasswordReset";
  }
}),
    V = e({
  redirectIntent: function redirectIntent(r) {
    return "confirmSignUp";
  }
}),
    b = e({
  authAttributes: function authAttributes(r, e) {
    var n,
        t,
        u = r.loginMechanisms[0];
    return {
      username: null !== (n = r.formValues[u]) && void 0 !== n ? n : r.formValues.username,
      password: null === (t = r.formValues) || void 0 === t ? void 0 : t.password
    };
  }
}),
    p = e({
  validationError: function validationError(r, e) {
    return e.data;
  }
}),
    g = e({
  remoteError: function remoteError(r, e) {
    var n;
    return "NoUserPoolError" === e.data.name ? "Configuration error (see console) – please contact the administrator" : (null === (n = e.data) || void 0 === n ? void 0 : n.message) || e.data;
  }
}),
    A = e({
  unverifiedAttributes: function unverifiedAttributes(r, e) {
    return e.data.unverified;
  }
}),
    _ = e({
  user: function user(r, e) {
    return e.data.user || e.data;
  }
}),
    y = e({
  username: function username(r, e) {
    var n = r.formValues,
        t = n.username,
        u = n.country_code;
    return u && (t = "".concat(u).concat(t)), t;
  }
}),
    E = e({
  codeDeliveryDetails: function codeDeliveryDetails(r, e) {
    return e.data.codeDeliveryDetails;
  }
}),
    D = e({
  authAttributes: function authAttributes(r, e) {
    return {
      username: r.formValues.username
    };
  }
}),
    N = e({
  formValues: function formValues(e, n) {
    var t,
        u = n.data,
        o = u.name,
        a = u.value;
    return r(r({}, e.formValues), ((t = {})[o] = a, t));
  }
}),
    q = e({
  formValues: function formValues(e, n) {
    return r(r({}, e.formValues), n.data);
  }
}),
    w = e({
  touched: function touched(e, n) {
    var t,
        u = n.data.name;
    return r(r({}, e.touched), ((t = {})["".concat(u)] = !0, t));
  }
}),
    P = e({
  formValues: function formValues(e, n) {
    var t,
        u,
        o = e.loginMechanisms[0],
        a = void 0 === o ? "username" : o;
    if (!e.formValues.phone_number && "phone_number" !== a) return e.formValues;
    var i = e.formValues,
        c = e.country_code,
        s = i.phone_number ? "phone_number" : "username",
        l = "".concat(null !== (u = i.country_code) && void 0 !== u ? u : c).concat(i[s]).replace(/[^A-Z0-9+]/gi, ""),
        d = r(r({}, i), ((t = {})[s] = l, t));
    return delete d.country_code, d;
  }
});

export { u as clearAttributeToVerify, o as clearChallengeName, i as clearError, c as clearFormValues, a as clearRequiredAttributes, s as clearTouched, l as clearUnverifiedAttributes, d as clearUsername, f as clearValidationError, w as handleBlur, N as handleInput, q as handleSubmit, P as parsePhoneNumber, m as setChallengeName, E as setCodeDeliveryDetails, h as setConfirmResetPasswordIntent, V as setConfirmSignUpIntent, b as setCredentials, p as setFieldErrors, g as setRemoteError, v as setRequiredAttributes, A as setUnverifiedAttributes, _ as setUser, y as setUsername, D as setUsernameAuthAttributes, t as stopActor };